import { render, staticRenderFns } from "./FlightOTPRatingBadge.vue?vue&type=template&id=72d0978d&scoped=true&"
import script from "./FlightOTPRatingBadge.vue?vue&type=script&lang=js&"
export * from "./FlightOTPRatingBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d0978d",
  null
  
)

export default component.exports